import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Row } from 'react-bootstrap';
import CurrentPageContext from '../../../contexts/CurrentPageContext';
import Ribbon from '../../../components/stateless/Ribbon';
import { TRACK_CLICK_PROMO_BANNER } from '../../../../src/web/utils/dataLayer';
import { RIBBON, FULLWIDTH } from './properties';
import { getForegroundColor, getBackgroundColor } from '../../../../src/web/utils/colorSelect';
import styles from './styles.scss';
import useEventTrigger from '../../../../modules/react/hooks/useEventTrigger';

const PromotionBanner = ({
  bgColor,
  fontColor = '#fff',
  displayStyle = FULLWIDTH,
  selectedPromos = [],
  facility,
}) => {
  const context = useContext(CurrentPageContext);
  const { foregroundClass } = getForegroundColor(fontColor, context);
  const { backgroundClass, backgroundHex } = getBackgroundColor(bgColor, context);
  const showPromos = selectedPromos.length && (selectedPromos[0] || selectedPromos[1]);
  const { addEvent } = useEventTrigger();

  const getAnalyticsPayload = () => ({
    facilityId: facility.id,
    displayStyle,
    promoClicked: true,
    timeStamp: Date.now(),
  });

  const trackAnalytics = (promotionType, publicDescription) => {
    const analyticsPayload = {
      promoType: promotionType,
      publicDescription,
      ...getAnalyticsPayload(),
    };
    addEvent(TRACK_CLICK_PROMO_BANNER, analyticsPayload, 'click');
  };

  const renderPromo = (promo, index) => (
    promo && (
      <div
        className={cx(styles.promos, foregroundClass)}
        key={index}
        onClick={() => trackAnalytics(promo.promotionType, promo.publicDescription)}
        aria-hidden="true"
      >
        <span>
          Use promo code <b>{promo.name}</b> for <b>{promo.description}</b>
        </span>
        {promo.endDate && (
          <span className={styles.endDate}>
            (expires on {promo.endDate})
          </span>
        )}
      </div>
    )
  );

  return (
    <div>
      {displayStyle === RIBBON ? (
        <div className={styles.ribbonContainer}>
          <div className={cx(styles.ribbon, styles.svg)}>
            <Ribbon color={backgroundHex} />
          </div>
          {showPromos ? (
            <div className={styles.ribbonText}>
              {selectedPromos.map((promo, index) => renderPromo(promo, index))}
            </div>
          ) : (
            <div className={styles.ribbonText}>
              <div className={styles.promos}>
                <h4 className={foregroundClass}>Select a promotion to feature.</h4>
              </div>
            </div>
          )}
        </div>
      ) : (
        <Row className={cx(styles.promoRow, backgroundClass)}>
          <div className={styles.promos}>
            {showPromos ? (
              <div>{selectedPromos.map((promo, index) => renderPromo(promo, index))}</div>
            ) : (
              <div className={styles.ribbonText}>
                <div className={styles.promos}>
                  <h4 className={cx(styles.bannerHeader, foregroundClass)} style={{ textAlign: 'center' }}>
                    Select a promotion to feature.
                  </h4>
                </div>
              </div>
            )}
          </div>
        </Row>
      )}
    </div>
  );
};

PromotionBanner.propTypes = {
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  displayStyle: PropTypes.string,
  selectedPromos: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    endDate: PropTypes.string,
  })),
  facility: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

PromotionBanner.defaultProps = {
  bgColor: undefined,
  fontColor: undefined,
  displayStyle: undefined,
  selectedPromos: [],
};

export default PromotionBanner;
